import { Grid, IconButton, Card, CardHeader, CardContent, Tooltip } from "@mui/material"
import EditIcon from "@mui/icons-material/Edit"
import { GridContainer, InfoText } from "components/common-styles"
import { useStores } from "stores/root-store"

const HeaderInfo = ({ onEditClicked }) => {
  const { BillOfMaterialStore } = useStores()

  const bomInfo = { ...BillOfMaterialStore.bomInfo }

  return (
    <Card>
      <CardHeader
        title="Bill of Materials"
        action={
          <Tooltip placement="top" title="Edit">
            <IconButton id="btnEdit" size="large" onClick={onEditClicked}>
              <EditIcon fontSize="inherit" />
            </IconButton>
          </Tooltip>
        }
      />
      <CardContent>
        <GridContainer container spacing={3}>
          <Grid item container md={6} xs={12}>
            <Grid item xs={4}>
              Item
            </Grid>
            <Grid item xs={8}>
              <InfoText id="item">{bomInfo?.item}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={5}>
              Quantity UM
            </Grid>
            <Grid item xs={7}>
              <InfoText id="quantity_um">{bomInfo?.quantity_um}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={4}>
              Item Description
            </Grid>
            <Grid item xs={8}>
              <InfoText id="item_desc">{bomInfo?.item_desc}</InfoText>
            </Grid>
          </Grid>

          <Grid item container md={6} xs={12}>
            <Grid item xs={5}>
              Revision Number
            </Grid>
            <Grid item xs={7}>
              <InfoText>{bomInfo?.revision_num}</InfoText>
            </Grid>
          </Grid>
        </GridContainer>
      </CardContent>
    </Card>
  )
}

export default HeaderInfo
